import * as inquiryCreators from '../creators/inquiryCreators';

let INITIAL_STATE = {
    inquiryType: null,
    isPrivacyConsent: false,
    inquiry: '',
    contact: {},
    targetSystems: [],
    recaptchaToken: null,
    verified: false,
    error: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case inquiryCreators.ADD_INQUIRY_TYPE:
            return {
                ...state,
                inquiryType: action.inquiryType
            };
        case inquiryCreators.ADD_INQUIRY_TEXT:
            return {
                ...state,
                inquiry: action.text
            };
        case inquiryCreators.CHANGE_INQUIRY_CONSENT:
            return {
                ...state,
                isPrivacyConsent: action.consent
            };
        case inquiryCreators.ADD_CONTACT_INFO:
            return {
                ...state,
                contact: action.data
            };
        case inquiryCreators.SET_TARGET_SYSTEMS:
            return {
                ...state,
                targetSystems: action.targetSystems
            }
        case inquiryCreators.ADD_RECAPTCHA_TOKEN:
            return {
                ...state,
                recaptchaToken: action.token
            };
        case inquiryCreators.VERIFY_PHONE_NUMBER_SUCCESS:
            return {
                ...state,
                verified: true,
                error: false
            }
        case inquiryCreators.VERIFY_PHONE_NUMBER_ERROR:
            return {
                ...state,
                verified: false,
                error: true
            }
        case inquiryCreators.RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

